import {Component, EventEmitter, Inject, Output} from "@angular/core";
import {contextPath} from "site";

@Component({
	selector: "subscribed-services-not-active-help-modal",
	template: `
		<modal
			modalClasses="modal-wide"
			(close)="onModalClosed()">
			<div class="modal_header text-center">
				<h3>
					Subscribed Services
				</h3>
			</div>
			<div class="modal_body text-center">
				<p>
					If you recently started services, provisioning LTE and Wi-Fi services for your device
					<b>usually completes within 1 hour, but may take longer</b>. Please contact Aviation Product Support
					if your services have not started after 12 hours.
				</p>
				<ng-container [ngSwitch]="showAdditionalTrialInformation">
					<p *ngSwitchCase="true">
						If the trial service has expired, please contact Aviation Product Support for information about
						an additional trial.
					</p>
					<p *ngSwitchDefault>
						If your device is new or your service has expired, please visit
						<a href="{{contextPath}}/connext/satellite-services/">Connected-Cockpit Services</a>
						for information about available services.
					</p>
				</ng-container>
				<aviation-product-support-contact-details
					[includeFlightDataServicesEmail]="true">
				</aviation-product-support-contact-details>
			</div>
			<div class="modal_footer">
				<div class="modal_buttons">
					<button
						class="button button-primary"
						(click)="onModalClosed()">
						OK
					</button>
				</div>
			</div>
		</modal>
	`,
})

export class SubscribedServicesNotActiveHelpModalComponent {
	@Output() modalClosed = new EventEmitter();
	contextPath = contextPath;

	isOemUser: boolean;
	isDealerUser: boolean;

	constructor(
		@Inject("isOemUser") userIsOem: boolean,
		@Inject("isDealerUser") userIsDealer: boolean,
	) {
		this.isOemUser = userIsOem;
		this.isDealerUser = userIsDealer;
	}

	onModalClosed() {
		this.modalClosed.emit();
	}

	get showAdditionalTrialInformation() {
		return this.isOemUser || this.isDealerUser;
	}
}
